export default "__VITE_ASSET__BqJjNlx0__"